import { render, staticRenderFns } from "./SupportedCategories.vue?vue&type=template&id=ec2b527e&scoped=true"
import script from "./SupportedCategories.vue?vue&type=script&lang=js"
export * from "./SupportedCategories.vue?vue&type=script&lang=js"
import style0 from "./SupportedCategories.vue?vue&type=style&index=0&id=ec2b527e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b527e",
  null
  
)

export default component.exports